export const usePageLoading = () => {
  const count = useState('pending-fetch-count', () => 0)
  const isLoading = useState('is-page-loading', () => false)

  function startFetch() {
    count.value++
    isLoading.value = true
  }

  function endFetch() {
    count.value = Math.max(0, count.value - 1)
    if (count.value === 0) {
      isLoading.value = false
    }
  }

  return {
    isLoading,
    startFetch,
    endFetch
  }
}